module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("9HPZo"))).then(() => parcelRequire('8rm4T'));